

<div *ngIf="prospectsMapSectionService.isVisible |async">
    <loading [isLoading]="this.prospectsMapSectionService.isLoading | async"></loading>
    <polygon-selector-with-levels
    *ngIf="!isInitializing"
        #polygonSelector
        [hierarchyLevels]="hierarchyLevels"
        [autoLoad]="true"
        [isSelectionActive]="isPolygonSelectionWithevelsActive"
        [serviceType]="serviceType"
        [useExternalLayers]="true"
        (selectionChange)="onHierarchySelectionChange($event)">
    </polygon-selector-with-levels>

    <simple-polygon-selector
    *ngIf="!isInitializing"
        #agebSelector
        [sourceName]="simpleSelectorPrefixAdd"
        [autoActivate]="false"
        [fillType]="simpleSelectorPolygonFillType"
        [cloropetConfig]="agebCloropetConfig"
        [textProperty]="'Description'"
        [useExternalLayers]="true">
    </simple-polygon-selector>

    <div class="main-zones-container">
        <div class="title-container">
            <span class="panel-title">Prospectos</span>
            <!-- <span class="panel-subtitle">(Zonas vs AGEBs)</span> -->
        </div>
        <div class="selected-zones">
            <div class="zone-semiCircle first-selection" [ngClass]="{'selected-zone': firstZone.isSelected, 'disabled': isLoadingZone}" (click)="firstZone.isSelected && resetToStart() && !isLoadingZone">
                {{ firstZone.name }}
            </div>
            <div class="zone-semiCircle second-selection" [ngClass]="{'selected-zone': secondZone.isSelected, 'disabled': isLoadingZone}" (click)="secondZone.isSelected && goBack() && !isLoadingZone">
                {{ secondZone.name }}
            </div>
        </div>
    </div>

    <prospects-panel *ngIf="secondZone.isSelected"></prospects-panel>
</div>
